<div id="preloader" *ngIf="loaderService.isLoading">
    <div id="status" *ngIf="loaderService.isLoading">
        <div class="spinner">
            <div class="double-bounce1"></div>
            <div class="double-bounce2"></div>
        </div>
    </div>
  </div>
